<template>
    <v-dialog-old ref="dialog" id="withdrawalReject">
        <form>
            <fieldset width="650">
                <legend>Причина отклонения</legend>
                <form>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Данные по вашему ФИО/ИНН не найдены в реестре самозанятых">
                        <span>Данные по вашему ФИО/ИНН не найдены в реестре самозанятых</span>
                    </label>
                    <label>
                        <input type="radio" v-model="unpublishReasonDefault" value="Другое">
                        <span>Другая причина</span>
                    </label>
                    <textarea v-model="unpublishReason" :disabled="unpublishReasonDefault !== 'Другое'"/>
                </form>
            </fieldset>
            <footer>
                <button class="green" @click.stop.prevent="onConfirmBtn" :disabled="!unpublishReasonDefault">
                    Отказать
                </button>
            </footer>
        </form>
    </v-dialog-old>
</template>

<script>
export default {
    data: function () {
        return {
            unpublishReasonDefault: '',
            unpublishReason: '',
        };
    },
    methods: {
        show () {
            this.unpublishReasonDefault = '';
            this.unpublishReason = '';
            this.$refs.dialog.show();
        },
        onConfirmBtn() {
            const reason = this.unpublishReasonDefault === 'Другое' ? this.unpublishReason : this.unpublishReasonDefault;
            if (!reason) {
                this.$modal('Нужно указать причину отклонения', {
                    name: 'ОК',
                    callback: () => {},
                }, {}, false);
                return;
            }

            this.$emit('rejected', reason);
            this.$refs.dialog.hide();
        },
    }
}
</script>

<style>
dialog#withdrawalReject {
    width: fit-content;
}
</style>
